import styled from '@emotion/styled';
import { theme } from 'style';

export const StyledDiv = styled.div(`
  width: 100%;
  height: 1px;
  background-color: ${theme.colors.lightBlueGrey};
`);